import { Injectable } from '@angular/core';
import { TuiDay, TuiTime, TuiValueTransformer } from '@taiga-ui/cdk';

@Injectable()
export class DateTimeTransformer implements TuiValueTransformer<[TuiDay, TuiTime | null] | null, Date> {
  fromControlValue(controlValue: Date): [TuiDay, TuiTime | null] | null {
    return controlValue ? [TuiDay.fromLocalNativeDate(controlValue), TuiTime.fromLocalNativeDate(controlValue)] : null;
  }

  toControlValue(value: [TuiDay, TuiTime | null] | null): Date {
    const [day, time] = value ?? [null, null];
    const date = day?.toLocalNativeDate() || new Date();
    const milliseconds = time?.toAbsoluteMilliseconds() || 0;

    return new Date(date.getTime() + milliseconds);
  }
}
